import {WJSvg} from './WJSvg';
import {CarSvg} from './CarSvg';
import {KeySvg} from './KeySvg';
import {BarSvg} from './BarSvg';
import {HashSvg} from './HashSvg';
import {BillSvg} from './BillSvg';
import {PlusSvg} from './PlusSvg';
import {UserSvg} from './UserSvg';
import {EditSvg} from './EditSvg';
import {LockSvg} from './LockSvg';
import {SepaSvg} from './SepaSvg';
import {InfoSvg} from './InfoSvg';
import {OpenSvg} from './OpenSvg';
import {CloseSvg} from './CloseSvg';
import {PhoneSvg} from './PhoneSvg';
import {HeartSvg} from './HeartSvg';
import {CheckSvg} from './CheckSvg';
import {EmailSvg} from './EmailSvg';
import {AlertSvg} from './AlertSvg';
import {GlobeSvg} from './GlobeSvg';
import {TrashSvg} from './TrashSvg';
import {CoffeeSvg} from './CoffeeSvg';
import {PayPalSvg} from './PayPalSvg';
import {MapPinSvg} from './MapPinSvg';
import {CameraSvg} from './CameraSvg';
import {FaceIDSvg} from './FaceIDSvg';
import {CancelSvg} from './CancelSvg';
import {GoogleSvg} from './GoogleSvg';
import {DollarSvg} from './DollarSvg';
import {RepeatSvg} from './RepeatSvg';
import {SearchSvg} from './SearchSvg';
import {GoBackSvg} from './GoBackSvg';
import {EyeOffSvg} from './EyeOffSvg';
import {CharitySvg} from './CharitySvg';
import {PadLockSvg} from './PadLockSvg';
import {InvoiceSvg} from './InvoiceSvg';
import {RefreshSvg} from './RefreshSvg';
import {MessageSvg} from './MessageSvg';
import {TwitterSvg} from './TwitterSvg';
import {ReceiveSvg} from './ReceiveSvg';
import {MoreTabSvg} from './MoreTabSvg';
import {LoanTabSvg} from './LoanTabSvg';
import {PayoneerSvg} from './PayoneerSvg';
import {CalendarSvg} from './CalendarSvg';
import {RejectedSvg} from './RejectedSvg';
import {DocumentSvg} from './DocumentSvg';
import {PayCheckSvg} from './PayCheckSvg';
import {MaximizeSvg} from './MaximizeSvg';
import {FIleTextSvg} from './FIleTextSvg';
import {MenuEditSvg} from './MenuEditSvg';
import {CardMenuSvg} from './CardMenuSvg';
import {PasswordSvg} from './PasswordSvg';
import {FacebookSvg} from './FacebookSvg';
import {BriefcaseSvg} from './BriefcaseSvg';
import {ArrowDownSvg} from './ArrowDownSvg';
import {PiggyBankSvg} from './PiggyBankSvg';
import {InsuranceSvg} from './InsuranceSvg';
import {TranslateSvg} from './TranslateSvg';
import {PercentageSvg} from './PercentageSvg';
import {KeyDetailsSvg} from './KeyDetailsSvg';
import {HelpCircleSvg} from './HelpCircleSvg';
import {DollarSignSvg} from './DollarSignSvg';
import {CreditCardSvg} from './CreditCardSvg';
import {RightArrowSvg} from './RightArrowSvg';
import {DepositTabSvg} from './DepositTabSvg';
import {InputCheckSvg} from './InputCheckSvg';
import {YellowCardSvg} from './YellowCardSvg';
import {ProfileUserSvg} from './ProfileUserSvg';
import {ElectricitySvg} from './ElectricitySvg';
import {AccountUserSvg} from './AccountUserSvg';
import {TransactionSvg} from './TransactionSvg';
import {DepositCheckSvg} from './DepositCheckSvg';
import {ShoppingCartSvg} from './ShoppingCartSvg';
import {MoreVerticalSvg} from './MoreVerticalSvg';
import {DashboardTabSvg} from './DashboardTabSvg';
import {StatisticPlusSvg} from './StatisticPlusSvg';
import {DollarDetailsSvg} from './DollarDetailsSvg';
import {MobilePaymentSvg} from './MobilePaymentSvg';
import {MoneyExchangeSvg} from './MoneyExchangeSvg';
import {MessageCircelSvg} from './MessageCircelSvg';
import {DepositPercentSvg} from './DepositPercentSvg';
import {NotificationTabSvg} from './NotificationTabSvg';
import {TopUpCreditCardSvg} from './TopUpCreditCardSvg';
import {TransactionCheckSvg} from './TransactionCheckSvg';
import {NotificationCheckSvg} from './NotificationCheckSvg';
import {StatisticExchangeSvg} from './StatisticExchangeSvg';
import {CalendarStatisticSvg} from './CalendarStatisticSvg';

export const svg = {
  WJSvg,
  KeySvg,
  BarSvg,
  CarSvg,
  UserSvg,
  PlusSvg,
  EditSvg,
  LockSvg,
  InfoSvg,
  OpenSvg,
  HashSvg,
  BillSvg,
  SepaSvg,
  AlertSvg,
  EmailSvg,
  HeartSvg,
  GlobeSvg,
  CheckSvg,
  TrashSvg,
  PhoneSvg,
  CloseSvg,
  PayPalSvg,
  DollarSvg,
  GoBackSvg,
  EyeOffSvg,
  GoogleSvg,
  RepeatSvg,
  SearchSvg,
  CoffeeSvg,
  CancelSvg,
  FaceIDSvg,
  MapPinSvg,
  CameraSvg,
  RefreshSvg,
  LoanTabSvg,
  TwitterSvg,
  ReceiveSvg,
  MoreTabSvg,
  MessageSvg,
  InvoiceSvg,
  CharitySvg,
  PadLockSvg,
  RejectedSvg,
  PayCheckSvg,
  PasswordSvg,
  FIleTextSvg,
  MaximizeSvg,
  CardMenuSvg,
  FacebookSvg,
  DocumentSvg,
  PayoneerSvg,
  MenuEditSvg,
  CalendarSvg,
  TranslateSvg,
  ArrowDownSvg,
  InsuranceSvg,
  BriefcaseSvg,
  PiggyBankSvg,
  YellowCardSvg,
  PercentageSvg,
  KeyDetailsSvg,
  RightArrowSvg,
  HelpCircleSvg,
  DollarSignSvg,
  InputCheckSvg,
  CreditCardSvg,
  DepositTabSvg,
  AccountUserSvg,
  ProfileUserSvg,
  TransactionSvg,
  ElectricitySvg,
  MoreVerticalSvg,
  ShoppingCartSvg,
  DashboardTabSvg,
  DepositCheckSvg,
  MessageCircelSvg,
  MobilePaymentSvg,
  MoneyExchangeSvg,
  DollarDetailsSvg,
  StatisticPlusSvg,
  DepositPercentSvg,
  TopUpCreditCardSvg,
  NotificationTabSvg,
  TransactionCheckSvg,
  CalendarStatisticSvg,
  StatisticExchangeSvg,
  NotificationCheckSvg,
};
